<template>
    <g-level class="g-px-6">
        <div>
            <g-typography tag="div">
                {{ title }}
            </g-typography>
            <g-typography tag="div" font-weight="semibold">
                {{ subtitle }}
            </g-typography>
        </div>
        <template slot="right">
            <slot/>
        </template>
    </g-level>
</template>
<script>
    export default {
        name: "CampaignOverviewFooter",
        props: {
            title: {
                type: String | Number,
            },
            subtitle: {
                type: String | Number,
            },
        }
    }
</script>
